import { render, staticRenderFns } from "./ModifyServicesForm.vue?vue&type=template&id=666205a4&scoped=true"
import script from "./ModifyServicesForm.vue?vue&type=script&lang=js"
export * from "./ModifyServicesForm.vue?vue&type=script&lang=js"
import style0 from "./ModifyServicesForm.vue?vue&type=style&index=0&id=666205a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666205a4",
  null
  
)

export default component.exports